import { useTranslation } from "react-i18next";
import Button from "./Button";
import { useHistory } from "react-router-dom";

export function IntegrationsMsgModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  const history = useHistory();

  const navigateAndClose = (path: string) => {
    history.push(path);
    onClose();
  };

  return (
    <>
      <h1 className="text-red-600 font-extrabold">
        {t("integrationmsgModal.importantAirBnb")}
      </h1>

      <span className="text-gray-500 font-normal text-base">
        {t("integrationsMsgModal.lastUpdate")}
      </span>

      <div className="p-3">
        <h2 className="text-gray-500 font-bold mt-3">AIRBNB</h2>

        <p className="text-gray-500 font-normal text-base">
          {t("dashboard.integrationMsg0")}
        </p>

        <p className="text-gray-500 font-normal text-base mt-3">
          {t("dashboard.integrationMsg2")}
        </p>

        <h2 className="text-gray-500 font-bold mt-3">
          Sms + Whatsapp Remind Check-in Online
        </h2>

        <p className="text-gray-500 font-normal text-base mt-3">
          {t("dashboard.integrationMsg3")}
        </p>

        <div className="flex flex-col w-full sm:w-1/2">
          <Button
            className="mt-5 text-sm px-2 whitespace-normal break-words text-center"
            label="Sms + Whatsapp Remind Check-In Online"
            onClick={() => navigateAndClose("modules/module#5")}
          />
          <Button
            className="mt-5 text-sm px-2 whitespace-normal break-words text-center"
            label="Sms Remind Check-In Online"
            onClick={() => navigateAndClose("modules/module#2")}
          />
          <Button
            className="mt-5 text-sm px-2 whitespace-normal break-words text-center"
            label="Whatsapp Remind Check-In Online"
            onClick={() => navigateAndClose("modules/module#6")}
          />
        </div>

        <h2 className="text-gray-500 font-bold mt-5">
          {t("dashboard.integrationMsg4")}
        </h2>
        <Button
          className="mt-5 text-sm"
          label={t("integration.readMore")}
          onClick={() => {
            window.open("https://my.vikey.it/guidait.pdf", "_blank");
            onClose();
          }}
        />
      </div>
    </>
  );
}

